import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return (
    <section className="flex min-h-[60vh] items-center bg-white">
      <div className="container-page text-center">
        <div className="font-display text-8xl font-bold text-brand-500">404</div>
        <h1 className="mt-4 font-display text-3xl font-bold text-ink-900">
          This Page Does Not Exist
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm text-ink-500">
          Sorry, the page you are looking for could not be found. It's just an accident that was not intentional.
        </p>
        <Link to="/" className="btn-primary mt-8">
          <ArrowLeft className="h-4 w-4" />
          Back to Home
        </Link>
      </div>
    </section>
  );
}
